import { formatContentTiles } from "./contentTiles";
import {
  KontentArticleOrSotDPage,
  KontentContentHedgehog,
  KontentContentProgram,
} from "../types";

export const formatProgram = (program: KontentContentProgram) => {
  const contentTile = formatContentTiles(
    program?.elements?.content_tile?.value
  );

  if (!contentTile || !contentTile[0]) return undefined;

  if (!contentTile[0]?.ctaHref) {
    contentTile[0].ctaHref = program.elements.url.value;
  }

  if (!contentTile[0]?.ctaAriaLabel) {
    contentTile[0].ctaAriaLabel = `Learn more about ${contentTile[0]?.subhead}`;
  }

  // if (!contentTile.ctaHref)
  return contentTile[0];
};

export const formatHedgehog = (hedgehog: KontentContentHedgehog) => {
  const contentTile = formatContentTiles(hedgehog.elements.content_tile.value);

  if (!contentTile) return undefined;

  if (!contentTile[0].ctaHref) {
    contentTile[0].ctaHref = hedgehog.elements.document?.value[0].url;
  }

  if (!contentTile[0]?.ctaAriaLabel) {
    contentTile[0].ctaAriaLabel = `Read ${contentTile[0]?.subhead || ""}`;
  }

  return contentTile[0];
};

export const formatArticleSotd = (article: KontentArticleOrSotDPage) => {
  const contentTileData =
    article?.elements?.content?.value[0]?.elements?.content_tile?.value;

  if (!contentTileData) return undefined;

  const contentTiles = formatContentTiles(contentTileData);

  if (contentTiles && !contentTiles[0].ctaHref) {
    contentTiles[0].ctaHref = article.elements?.url?.url;
  }

  if (contentTiles && !contentTiles[0].date) {
    contentTiles[0].date = article.elements?.display_publish_date.value;
  }

  if (contentTiles && !contentTiles[0]?.ctaAriaLabel) {
    contentTiles[0].ctaAriaLabel = `Read ${contentTiles[0]?.subhead}`;
  }

  return contentTiles ? contentTiles[0] : undefined;
};
